import styled from "styled-components";
import {
  ContentBodyWrapper,
  ContentHeaderWrapper,
  ContentWrapper,
  PopupContainer,
} from "../../../styles/popup";

export const ReservationEditPopupContainer = styled(PopupContainer)``;
export const ReservationEditPopupContentWrapper = styled(ContentWrapper)`
  width: 616px;
  height: 890px;
  overflow-y: hidden;
`;
export const ReservationEditPopupContentHeaderWrapper = styled(
  ContentHeaderWrapper,
)`
  margin-top: 25px;
`;
export const ReservationEditPopupContentBodyWrapper = styled(
  ContentBodyWrapper,
)`
  gap: 29px;
  flex-direction: column;
  margin-bottom: 33.72px;
`;
export const ImageDropWrapper = styled.div`
  position: relative;
  width: 536px;
  height: 715px;
  gap: 0px;
  border-radius: 15px;
  opacity: 0.8px;
  border: 5px dashed #bebebe;
  box-sizing: border-box;
`;
export const ImageDropInitialContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  h2 {
    font-family: Pretendard;
    font-size: 30px;
    font-weight: 600;
    line-height: 35.8px;
    letter-spacing: -0.16500000655651093px;
    text-align: center;
  }
  p {
    font-family: Pretendard;
    font-size: 20px;
    font-weight: 300;
    line-height: 23.87px;
    letter-spacing: -0.16500000655651093px;
    text-align: center;

    margin: 0px;
  }
  svg path {
    fill: rgba(203, 203, 203, 1);
  }
`;

export const DataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 701px;
  height: 632px;
  gap: 20px;
`;

export const InputDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 761px;
  height: 716px;
  justify-content: space-between;
`;

export const DataRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const ReservationEditActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

export const Label = styled.label`
  font-family: Pretendard;
  font-size: 20.23px;
  font-weight: 600;
  line-height: 24.15px;
  text-align: left;

  flex: 1;
`;

export const Value = styled.label`
  display: flex;
  padding: 8px;
  align-items: center;
  font-family: Pretendard;
  font-size: 10.79px;
  font-weight: 500;
  line-height: 12.88px;
  text-align: left;
  border: 0.67px solid var(--Black-200, rgba(183, 183, 183, 1));
  flex: 3;
`;

export const TournamentListWrapper = styled.div`
  background-color: white;
  width: 662px;
  padding: 40px;
  display: flex;
  flex-direction: column;
`;
